import { Car, ChevronLeft, ChevronRight, Clock, Mail, Map, Menu, Package, X } from "lucide-react";
import React, { useState } from "react";

const HERO_BG = "https://i.postimg.cc/t4YRDRbd/6390.jpg";

export default function HeroCard31() {

    const [openNavXs ,setOpenNavXs] = useState(false)
  return (
    <>
      <header className="auto-wrapper">

        {/* TOP CONTACT BAR */}
      

        {/* MAIN NAVBAR */}
       

        {/* HERO SECTION */}
        <section className="auto-hero">

          {/* Background image */}
          <div
            className="auto-bg"
            style={{ backgroundImage: `url('${HERO_BG}')` }}
          />

          {/* dark overlay */}
          <div className="auto-overlay" />

          {/* CONTENT */}
          <div className="auto-content">
            <h1 className="auto-title">UPSC Classes For Aspirants</h1>
            <div className="auto-divider">
              <span></span>
              <span className="divider-icon"><Package style={{"margin":"10px"}} size={36} /> </span>
              <span></span>
            </div>
            <p className="auto-sub">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
              ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
              aliquip ex ea commodo consequat.
            </p>
            <button className="auto-cta">Discover More</button>
          </div>

          {/* ARROWS */}
          <button className="auto-prev"><ChevronLeft  size={16} /> </button>
          <button className="auto-next"><ChevronRight  size={16} /></button>

          {/* DOTS */}
          <div className="auto-dot-cm-hc31s">
            <div className="dot-cm-hc31 "></div>
            <div className="dot-cm-hc31"></div>
            <div className="dot-cm-hc31"></div>
          </div>

        </section>

      </header>

      <style>{`
/* ---------- BASE ---------- */
.auto-wrapper {
  font-family: Inter, Arial, sans-serif;
  color: #fff;
  overflow: hidden;
}

/* ---------- TOP BAR ---------- */
.auto-topbar {
  background: #ececec;
  color: #333;
  padding: 6px 0;
}
.auto-top-inner {
  width: min(1200px, 92%);
  margin: auto;
  display: flex;
  justify-content: flex-end;
  gap: 22px;
  font-size: 0.9rem;
  font-weight: 600;
}
.auto-top-inner-item{display:flex;justify-content:left;gap:10px}
/* ---------- NAVBAR ---------- */
.auto-navbar {
  background: #000;position:relative;
  padding: 12px 0;z-index: 10;
}
.auto-nav-inner {
  width: min(1200px, 92%);
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* LOGO */
.auto-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}
.auto-logo-box {
  background: #ff5400;transform: translateX(-63px) translateY(40px) skewX(-20deg) translateZ(-20px);;;
  padding: 10px 28px;width:130px;display:flex;justify-content:left;gap:10px;
  border-radius: 6px;
}
.car-icon {
  font-size: 1.4rem;
}
.logo-text {
  font-weight: 900;
  font-size: 1.1rem;
  letter-spacing: 1px;
}

/* MENU */
.auto-menu ,.auto-menu-xs{
  display: flex;
  gap: 22px;position:relative;z-index:999;
  list-style: none;
}
  
.auto-menu a ,.auto-menu-xs a{
  color: #fff;
  text-decoration: none;
  font-weight: 600;
}
.auto-menu a.active-cm-hc31 ,.auto-menu-xs  a.active-cm-hc31 {
  color: #ff5400;  
}.auto-menu a:hover ,.auto-menu-xs a:hover {
  color: #ff5400; transition: transform 220ms ease;  
}
.auto-menu a.buy  ,.auto-menu-xs a.buy  {
  background: #ff5400;
  padding: 6px 14px;
  border-radius: 4px;
}
  .auto-menu-xs {background:#222222;padding:10px 15px;
  display: block;width:100px;position:absolute;top:45px;right:0px;
 
}
.auto-menu-xs li {
  color: #fff;padding:8px;
  text-decoration: none;
  font-weight: 600;
}
.cm-hc31-menu-xs{width:20px;position:absolute;right:10px;z-index:999999;}
/* ---------- HERO SECTION ---------- */
.auto-hero {
  position: relative;
  height: 82vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Background image */
.auto-bg {
  position: absolute;
  inset: 0;filter: blur(4px) saturate(0.5) brightness(0.85);
  background-size: cover;
  background-position: center;
  transform: scale(1.03);
  z-index: 0;
}

/* dark overlay */
.auto-overlay {
  position: absolute;margin-top:-8px;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 1;
}

/* CONTENT */
.auto-content {
  position: relative;
  z-index: 3;
  text-align: center;
  max-width: 750px;
  padding: 0 16px;
}

.auto-title {
  font-size: clamp(1.8rem, 4.4vw, 3.2rem);
  font-weight: 900;
}

.auto-divider {
  margin: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
}
.auto-divider span {
  width: 80px;margin-bottom:22px;
  height: 2px;
  background: #fff;
  opacity: 0.5;
}
.divider-icon {position:relative;
  font-size: 1.4rem;
}

.auto-sub {
  max-width: 620px;
  margin: 14px auto 24px;
  font-size: 1rem;
  opacity: 0.9;
  line-height: 1.6;
}

.auto-cta {
  background: #ff5400;
  border: none;
  padding: 14px 26px;
  color: #fff;
  border-radius: 28px;
  font-weight: 800;
  cursor: pointer;
  font-size: 1.05rem;
}

/* ARROWS */
.auto-prev,
.auto-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255,255,255,0.26);
  border: none;
  padding: 10px 14px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 4;
  font-size: 1.3rem;
  color: white;
}
.auto-prev { left: 30px; }
.auto-next { right: 30px; }

/* DOTS */
.auto-dot-cm-hc31s {
  position: absolute;
  bottom: 26px;
  display: flex;
  gap: 14px;
}
.dot-cm-hc31 {
  width: 12px;
  height: 12px;
  background: rgba(255,255,255,0.6);
  border-radius: 50%;
}
.dot-cm-hc31.active-cm-hc31 {
  background: #ff5400;
}
  
/* RESPONSIVE */
@media (max-width: 950px) {
.auto-menu{display:none}

.auto-logo-box {
 transform: translateX(-3px) translateY(40px) skewX(-20deg) translateZ(-20px);;;
  padding: 10px 8px;width:130px;display:flex;justify-content:left;gap:10px;
  border-radius: 6px;
}}

      `}</style>
    </>
  );
}
